import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DataResponseInterceptor implements HttpInterceptor {
  constructor() {}

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      map((res) => {
        if (res instanceof HttpResponse) {
          if (res.body && res.body.data) {
            const newRes: any = res;
            newRes.body = res.body.data;
            return newRes;
          }
        }
        return res;
      }),
    );
  }
}
